import { render, staticRenderFns } from "./orentation_stage.vue?vue&type=template&id=b02f2ee2&scoped=true&"
import script from "./orentation_stage.vue?vue&type=script&lang=js&"
export * from "./orentation_stage.vue?vue&type=script&lang=js&"
import style0 from "./orentation_stage.vue?vue&type=style&index=0&id=b02f2ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02f2ee2",
  null
  
)

export default component.exports